import React, { useEffect } from "react";
import { pageNotFoundAnimation } from "../animations/desktop";
import CustomLink from "../components/CustomLink";
import PageNotFoundBg from "../images/404.webp";

function PageNotFound() {

  useEffect(() => {
    pageNotFoundAnimation();
  },[])

  return (
    <div className="ahdc-page-not-found ahdc-page-not-found--animate">
      <span className="ahdc-page-not-found__text ahdc-page-not-found__text--1 ahdc-page-not-found--animate">oops!</span>
      <h1 className="ahdc-page-not-found__text ahdc-page-not-found__text--2 ahdc-page-not-found--animate">404 - page not found</h1>
      <div className="ahdc-page-not-found__img-wrapper ahdc-page-not-found--animate">
        <img
          className="ahdc-page-not-found__img"
          src={PageNotFoundBg}
          alt="Page Not Found - Alaa Hassoun"
        />
      </div>
      <CustomLink path="/" text="go back home" border={false}/>
    </div>
  );
}

export default PageNotFound;
